import script from "./WhatsappLink.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsappLink.vue?vue&type=script&setup=true&lang=js"

import "./WhatsappLink.vue?vue&type=style&index=0&id=1ef8bf96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef8bf96"]])

export default __exports__